export function stickyHeader(scrollOffset, pageHeadHeight) {
  if (scrollOffset > pageHeadHeight) {
    $("body").addClass("scrolling");
  } else {
    $("body").removeClass("scrolling");
  }
}
